import { render, staticRenderFns } from "./Segmentation.vue?vue&type=template&id=5439a2be"
import script from "./Segmentation.vue?vue&type=script&lang=js"
export * from "./Segmentation.vue?vue&type=script&lang=js"
import style0 from "./Segmentation.vue?vue&type=style&index=0&id=5439a2be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports